import defaultLocales from 'globals/locales/default';
import { Dispatch } from 'react';
import {
  LargeToggleTabButtonDataProps,
  LargeToggleTabButtonProps,
} from './LargeToggleTabButton/LargeToggleTabButton';

const {
  chart: { tabs: tabsLocales },
} = defaultLocales.dashboardPage;

interface GetTabsTabsProps {
  dataTabs: LargeToggleTabButtonDataProps[];
  activeId: number;
  setActiveId: Dispatch<number>;
}

export const getTabProps = ({
  dataTabs,
  activeId,
  setActiveId,
}: GetTabsTabsProps): LargeToggleTabButtonProps[] =>
  dataTabs.map(({ effectiveness, id, ...otherProps }) => ({
    id,
    ...otherProps,
    effectiveness: {
      ...effectiveness,
      label: tabsLocales[id].effectivenessLabel,
    },
    percentageLabel: tabsLocales[id].percentageLabel,
    selected: activeId === id,
    onClick: (): void => setActiveId(id),
  }));

// const values = Array.from(Array(11).keys());
//
// export const getChartData = (): FsConversionChartSingleRowDataProps[] =>
//   Array.from(Array(30).keys()).map((day) => ({
//     x: new Date(2021, 7, day + 1).getTime(),
//     y: values[Math.floor(values.length * Math.random())],
//   }));
